export interface ReduxRouterMapStateReturnType {}

export const ReduxRouterMap = (): ReduxRouterMapStateReturnType => {
  return {}
}

export default ReduxRouterMap
